export const demoIntel = {
  "94cameron_boozer": [
    {
      title:
        "Future Duke Basketball Twins Suffer Second Straight Loss in New York",
      content:
        "Duke basketball recruiting prizes Cayden and Cameron Boozer now have a long break before getting a chance to return to their winning ways.",
      image:
        "https://images2.minutemediacdn.com/image/upload/c_crop,w_3872,h_2178,x_0,y_28/c_fill,w_2160,ar_16:9,f_auto,q_auto,g_auto/images%2FImagnImages%2Fmmsport%2Fblue_devil_country%2F01jga6hx19pm1m2gqgra.jpg",
      link: "https://www.si.com/college/duke/basketball/future-duke-basketball-twins-second-loss-new-york-12-29-24",
      date: "12/29/2024",
    },
    {
      title: "2024 City of Palms Classic Recap: Top Prospects Who Impressed",
      content:
        "The 2024 City of Palms Classic took place last week in Fort Myers, Florida, bringing together top high school players and programs nationwide.",
      image:
        "https://static.wixstatic.com/media/b64ded_fcea67c383354c8298c235e5c5e18ca8~mv2.jpg/v1/fill/w_1480,h_1084,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/b64ded_fcea67c383354c8298c235e5c5e18ca8~mv2.jpg",
      link: "https://www.babcockhoops.com/post/2024-city-of-palms-classic-recap-top-prospects-who-impressed",
      date: "12/29/2024",
    },
    {
      title: "Dan Hurley shows up to watch Duke signee Cameron Boozer",
      content:
        "Dan Hurley shows up to watch Duke signee Cameron Boozer’s matchup vs 4-star UConn commit",
      image:
        "https://staticg.sportskeeda.com/editor/2024/12/13d11-17353584433295-1920.jpg",
      link: "https://www.sportskeeda.com/college-basketball/news-dan-hurley-shows-watch-duke-signee-cameron-boozer-s-matchup-vs-4-star-uconn-commit",
      date: "12/28/2024",
    },
  ],
  "22nikolas_khamenia": [
    {
      title: "Duke Recruiting: Nikolas Khamenia Update!",
      content:
        "Here’s a comparison you probably haven’t heard before: NBA legend Jason Kidd and Duke recruit Nikolas Khamenia.",
      image:
        "https://www.desertsun.com/gcdn/authoring/authoring-images/2024/12/27/PPAS/77252821007-20241226-harvard-westlake-bellevue-026.jpg?width=1320&height=952&fit=crop&format=pjpg&auto=webp",
      link: "https://www.dukebasketballreport.com/2024/12/30/24331957/duke-basketball-recruiting-nikolas-khamenia-jason-kidd",
      date: "12/30/2024",
    },
    {
      title:
        "The ultimate team guy': Duke commit Nikolas Khamenia has a Jason Kidd-like mentality",
      content:
        "In Rancho Mirage for the Desert Holiday Classic, Khamenia has shown that a player doesn't need to score a lot of points to dominate.",
      image:
        "https://www.desertsun.com/gcdn/authoring/authoring-images/2024/12/27/PPAS/77252789007-20241226-harvard-westlake-bellevue-002.jpg?width=1320&height=980&fit=crop&format=pjpg&auto=webp",
      link: "https://www.desertsun.com/story/sports/high-school/basketball/2024/12/29/duke-signee-nikolas-khamenia-is-not-your-typical-basketball-star/77292337007/",
      date: "12/29/2024",
    },
    {
      title: "Jon Scheyer 'Blown Away' by Duke Basketball Signee's Arsenal",
      content:
        "Harvard-Westlake School (Calif.) senior forward Nikolas Khamenia committed to Duke basketball head coach Jon Scheyer and the Blue Devils back on Oct. 22. ",
      image:
        "https://img-s-msn-com.akamaized.net/tenant/amp/entityid/AA1uBbxv.img?w=768&h=432&m=6&x=374&y=140&s=67&d=67",
      link: "https://www.msn.com/en-us/sports/other/jon-scheyer-blown-away-by-duke-basketball-signees-arsenal/ar-AA1uB6Ny",
      date: "11/29/2024",
    },
  ],
  "36chris_cenac": [
    {
      title:
        "Chris Cenac Jr Has a New Home at Link Academy and His Sights Set on a National Championship",
      content:
        "For a senior in high school, Chris Cenac Jr’s already got an above-average résumé. Louisiana high school state champion.",
      image:
        "https://d1l5jyrrh5eluf.cloudfront.net/wp-content/uploads/2024/12/GettyImages-2159857014-scaled.jpg",
      link: "https://www.slamonline.com/the-magazine/253/chris-cenac-jr/",
      date: "3 days ago",
    },
    {
      title:
        "5-star Houston Cougars commit Chris Cenac shares 1-word reaction to Inglewood star Jason Crowe Jr.'s post",
      content:
        "Cenac has led his team to an 8-2 record. But they are about to face their most daunting task yet this Sunday against the Boozer Twins. ",
      image:
        "https://staticg.sportskeeda.com/editor/2024/12/eb689-17353154930874-1920.jpg",
      link: "https://www.sportskeeda.com/us/high-school-sports/news-5-star-houston-cougars-commit-chris-cenac-shares-1-word-reaction-inglewood-star-jason-crowe-jr-s-post",
      date: "12/27/2024",
    },
    {
      title:
        "Houston lands C Chris Cenac Jr., its highest-ranked recruit in modern era",
      content:
        "Cenac is the highest-ranked recruit in the history of the Houston program, according to 247Sports.",
      image:
        "https://cdn.vox-cdn.com/thumbor/-WZnRe26FCZ7wiyXfWk9Es2kFjw=/0x0:5030x3353/1820x1213/filters:focal(2621x1474:3425x2278):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/73710842/2160479944.0.jpg",
      link: "https://www.espn.com/mens-college-basketball/story/_/id/42629094/houston-lands-c-chris-cenac-jr-highest-ranked-recruit-modern-era",
      date: "11/27/2024",
    },
  ],
  "2caleb_wilson": [
    {
      title:
        "Here Comes the Boom: Did Caleb Wilson Silently Commit to Kentucky?",
      content:
        "Here Comes the Boom returns this Thursday for a special holiday edition, addressing all the latest in Kentucky Basketball recruiting. ",
      image:
        "https://on3static.com/cdn-cgi/image/height=417,width=795,quality=90,fit=cover,gravity=0.5x0.5/uploads/dev/assets/cms/2024/12/26095313/Here-Comes-the-Boom.jpg",
      link: "https://www.on3.com/teams/kentucky-wildcats/news/here-comes-the-boom-caleb-wilson-silent-commit-kentucky/",
      date: "12/26/2024",
    },
    {
      title:
        "Kentucky 2025 five-star target Caleb Wilson is nearing a decisions",
      content: "Will Caleb Wilson play his college basketball for Mark Pope?",
      image:
        "https://images2.minutemediacdn.com/image/upload/c_crop,w_3000,h_1687,x_0,y_0/c_fill,w_2160,ar_16:9,f_auto,q_auto,g_auto/images%2FImagnImages%2Fmmsport%2Fwildcats_today%2F01jfwpqrkez8kph5k97c.jpg",
      link: "https://www.si.com/college/kentucky/men-s-basketball/kentucky-2025-five-star-target-caleb-wilson-is-nearing-a-decisions",
      date: "12/24/2024",
    },
    {
      title:
        "More positive buzz for Kentucky (and its NIL) in the recruitment of Caleb Wilson",
      content:
        "While many thought that the exodus of John Calipari to Arkansas meant the Kentucky Wildcats would stop getting 5-star prospects, Mark Pope has emphatically put that to rest.",
      image:
        "https://cdn.vox-cdn.com/thumbor/P9CvFzCUzXo0iiuGc2ykPTXDRTM=/0x0:4290x2856/1820x1213/filters:focal(1802x1085:2488x1771):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/73810364/2191008387.0.jpg",
      link: "https://www.aseaofblue.com/2024/12/26/24329543/caleb-wilson-kentucky-basketball-nil-north-carolina-tar-heels-unc",
      date: "12/24/2024",
    },
  ],
  "78kanon_cathcings": [
    {
      title: "The real test begins now for Kevin Young and the BYU Cougars",
      content:
        "The first-year head coach and his freshmen phenoms will get their first taste of the Big 12 Conference.",
      image:
        "https://www.sltrib.com/resizer/v2/67JVJAYOZZBZNDBVTSIIXUBI4I.jpg?auth=e64782c7d163d242aa841b15c58e3c30404d735a9f970704af65f4869e20f3d1&width=1024&quality=88",
      link: "https://www.sltrib.com/sports/byu-cougars/2024/12/30/what-byus-kevin-young-kanon/",
      date: "12/30/2024",
    },
    {
      title:
        "From Provo to NBA Draft Boards: BYU’s Egor Demin and Kanon Catchings Impress in Season Opener",
      content:
        "BYU’s Egor Demin and Kanon Catchings impressed in their season opener against Utah State.",
      image:
        "https://static.wixstatic.com/media/b64ded_ba94fb029f1648d9a15e3c3be3a6f287~mv2.jpg/v1/fill/w_1480,h_986,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/b64ded_ba94fb029f1648d9a15e3c3be3a6f287~mv2.jpg",
      link: "https://www.babcockhoops.com/post/from-provo-to-nba-prospects-byu-s-egor-demin-and-kanon-catchings-impress-in-season-opener",
      date: "11/29/2024",
    },
    {
      title: "Kanon Catchings, projected 2025 1st-round pick, commits to BYU",
      content:
        "BYU’s Egor Demin and Kanon Catchings impressed in their season opener against Utah State.",
      image:
        "https://a2.espncdn.com/combiner/i?img=%2Fphoto%2F2024%2F0618%2Fr1347301_1296x729_16%2D9.jpg&w=1140&cquality=40&format=jpg",
      link: "https://www.espn.com/mens-college-basketball/story/_/id/40378257/kanon-catchings-projected-2025-1st-round-pick-commits-byu",
      date: "11/27/2024",
    },
  ],
  default: [
    {
      title: "",
      content: "",
      image: "",
      link: "",
      date: "",
    },
    {
      title: "",
      content: "",
      image: "",
      link: "",
      date: "",
    },
    {
      title: "",
      content: "",
      image: "",
      link: "",
      date: "",
    },
  ],
};
